export enum DocumentType {
    PolizaDigitalCompleta = 'PDFPO',
    PolizaDigitalReducida = 'PDFRE',
    FacturaOrganizador = 'FACOR',
    CuponeraDePago = 'CHEQU',
    FacturaAsegurado = 'FACAS',
    CertificadoDePolizaSinDeudaVencida = 'CPSDV',
    FacturaProductor = 'FACPR',
    CuadernilloDeAsistencia = 'CUASI',
    CertificadoCoberturaRcCarteles = 'CERRT',
    CertificadoCoberturaCalderas = 'CCOCA',
    CertificadoCoberturaAscensores = 'CCOAS',
    ConstanciaCoberturaConsorcio = 'CERCC',
    ConstanciaHogarCombinadoFamiliar = 'CERCH',
    ConstanciaCoberturaAPConClausula = 'CAPCC',
    ConstanciaCoberturaAPSinClausula = 'CAPSC',
    ConstanciaCoberturaAPBeneficiarioPrimerTermino = 'CAPBR',
    ConstanciaCoberturaComercio = 'CERCR',
    ConstanciaCoberturaVidaColectivo = 'VIDCO',
    ConstanciaCoberturaVidaSaldoDeudor = 'CCVSD',
    ConstanciaCoberturaSepelio = 'CCSEP',
    ConstanciaCoberturaVidaObligatorioCCVOB = 'CCVOB',
    ConstanciaCoberturaVidaObligatorioVIDOB = 'VIDOB',
    ConstanciaCoberturaVehiculos = 'CERCA',
    TarjetaCirculacion = 'TARCI',
}